import { IconSend } from '@tabler/icons-react-native';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { Button } from 'app/design/primitives/button';
import { GUARDIAN_BLUE } from 'app/shopify/components/feedback/GuardianBadge';
import { useTranslation } from 'react-i18next';
import { localeAwareFormatDistance } from 'app/lib/date';
import { useNavigation } from 'app/hooks/navigation';
import { navigateToChat } from 'app/screens/chat/navigator-helper';
import type { Listing } from 'app/types/listing';
import { useUser } from 'app/network/user';
import MemberCard from 'app/screens/groups/member-card';
import { Pressable } from 'react-native';
import { navigateToUserProfile } from 'app/screens/billboard/navigator-helper';

export function GuardianBanner({ listing }: { listing: Listing }) {
  const { t } = useTranslation('guardian');
  const { data: user } = useUser();
  if (!listing.guardianId || listing.userId !== user?.id) return null;
  return (
    <Row
      justifyContent="center"
      alignItems="center"
      gap="spacing.general.x1"
      padding="spacing.general.x3"
      style={{ backgroundColor: GUARDIAN_BLUE }}
    >
      <IconSend size={16} color="white" />
      <Text color="white" fontSize={12} flexShrink={1} textAlign="center">
        {t('banner', {
          ago: listing.guardianSince ? localeAwareFormatDistance(new Date(), new Date(listing.guardianSince)) : '',
        })}
      </Text>
    </Row>
  );
}

export function GuardianSection({ listing }: { listing: Listing }) {
  const { t } = useTranslation('guardian');
  const { data: user } = useUser();
  const navigation = useNavigation();
  if (!listing.guardianId) return null;
  const guardian = listing.guardian;
  return (
    <Column padding="spacing.general.x4" gap="spacing.general.x2">
      <Text fontWeight="600">
        {t('guardian')}{' '}
        {listing.guardianSince
          ? t('since', { ago: localeAwareFormatDistance(new Date(), new Date(listing.guardianSince)) })
          : ''}
      </Text>
      {guardian ? (
        <Pressable accessibilityRole="button" onPress={() => navigateToUserProfile(navigation, guardian.id)}>
          <MemberCard
            {...guardian}
            addresses={guardian.profile?.city ? [{ city: guardian.profile.city }] : undefined}
            lastSeenAt={
              guardian.lastSeenAt ?? (guardian.profile?.lastSeenAt ? new Date(guardian.profile.lastSeenAt) : undefined)
            }
          />
        </Pressable>
      ) : null}
      {listing.userId === user?.id && listing.guardianChannelId ? (
        <Button
          accessibilityRole="button"
          variant="primary"
          minHeight={48}
          style={{ borderRadius: 24 }}
          onPress={() => navigateToChat(navigation, listing.guardianChannelId!)}
        >
          {t('contact')}
        </Button>
      ) : null}
    </Column>
  );
}
